import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { getBasePath } from "./../../helpers";

import "./card.scss";

function CardToy({ toyData }) {
  if (!toyData) return null;
  const coverImage =
    toyData.images.find((image) => image.is_cover) || toyData.images[0];
  return (
    <div
      className="card"
      style={isMobile ? { minWidth: "100%" } : { width: "300px" }}
    >
      <img
        src={`${getBasePath()}/${coverImage?.image}`}
        className="img-fluid card-img-top"
        alt="Imagem de Teste"
      />
      <div className="card-body">
        <p className="card-text">{toyData.brand.name}</p>
        <Link className="card-title" to={`/brinquedos-detalhes/${toyData.id}`}>
          {toyData.name}
        </Link>
        <p className="card-price">
          R$ {toyData.rental?.monthly_price}
          <small className="text-body-secondary">/mês</small>
        </p>
      </div>
    </div>
  );
}

export default CardToy;
